const stateChangeSuccess = $transitions => {
	$transitions.onSuccess({to: '*'}, trans => {
		const IntercomService = trans.injector().get('IntercomService');
		const NavSvc = trans.injector().get('NavSvc');
		const QueuePromisesSvc = trans.injector().get('QueuePromisesSvc');

		// start/stop Intercom
		if (!NavSvc.isStatePublic(trans.to().name)) {
			IntercomService.boot();
		} else {
			IntercomService.shutdown();
		}

		QueuePromisesSvc.reset();

		// resume transition
		// const $urlService = trans.injector().get('$urlService');
		// $urlService.sync();
	});
};
stateChangeSuccess.$inject = ['$transitions'];
export default stateChangeSuccess;
